module.exports = __webpack_public_path__ + "static/media/final-coquetel.33b572d4.png";